import { useEffect } from 'react';

/* Public marketing/signup pages are designed light-only. The app theme
   defaults to DARK (adds `dark` to <html>), which turned shadcn Cards dark
   under gray-900 text — invisible titles for new visitors. This hook pins
   the page to light while mounted and restores the app theme on unmount. */
export default function useForceLightTheme() {
  useEffect(() => {
    const html = document.documentElement;
    const hadDark = html.classList.contains('dark');
    const hadBodyDark = document.body.classList.contains('ht-theme-dark');
    html.classList.remove('dark');
    document.body.classList.remove('ht-theme-dark');
    document.body.classList.add('ht-theme-light');
    return () => {
      if (hadDark) html.classList.add('dark');
      if (hadBodyDark) {
        document.body.classList.remove('ht-theme-light');
        document.body.classList.add('ht-theme-dark');
      }
    };
  }, []);
}
